import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { api } from '../services/api'
import { Document } from '../services/documents.service'

type State = {
  favorites: Document[]
}

type Actions = {
  setFavorites: (favorites?: Document[]) => void
  logout: () => void
}

export const useFavorites = create(
  persist<State & Actions>(
    (set) => ({
      favorites: [],
      setFavorites: (favorites?: Document[]) => {
        return set(() => ({
          favorites,
        }))
      },
      logout: () => {
        return set(() => ({
          favorites: [],
        }))
      },
    }),
    {
      name: 'favorites',
    },
  ),
)
